import commonFunc from '~/assets/js/commonHelper.js'
export default function ({ redirect, req }) {
  // extract old tag search link;
  if (req) {
    const tagSearch = commonFunc.extractTagSearch(req.query.keyword)
    if (tagSearch) {
      const param = {}
      const keyword = tagSearch.keyword
      if (keyword !== '') {
        param.keyword = keyword
      }
      if (req.query.cri) {
        param.cri = req.query.cri
      }
      param.tag = tagSearch.tag
      if (req.query.sopt) {
        param.sopt = req.query.sopt
      }
      const params = []
      Object.keys(param).forEach(function(key) {
        params.push(key + '=' + encodeURIComponent(param[key]))
      })
      const url = '/' + req.path + '?' + params.join('&')
      return redirect(url)
    }
  }
}
